// Front-end only — no back-end counterpart.

export type FormMode = 'create' | 'edit'

export const FormMode = {
  CREATE: 'create',
  EDIT: 'edit'
} satisfies Record<string, FormMode>

export const FormModeValues: readonly FormMode[] = Object.values(FormMode)
